export const PROXY = {
  heroku: 'https://prestokast-proxy.herokuapp.com',
  firebase: 'https://prestokast-proxy.firebaseapp.com',
};
